<template>
  <section ref="root" class="shop">
    <div class="shop__inner">
      <p class="eyebrow shop__eyebrow" data-shop-in>(Shop)</p>
      <h1 ref="title" class="display shop__title">Almost there</h1>
      <p class="shop__text" data-shop-in>Get ready. Coppados merch is on its way.</p>
      <div class="shop__dots" aria-hidden="true" data-shop-in>
        <span></span><span></span><span></span>
      </div>
    </div>
    <MarqueeText class="shop__marquee" :items="['Coming soon', 'Coppados shop']" variant="band" :speed="70" />
  </section>
</template>

<script>
import { gsap, SplitText, prefersReducedMotion } from '@/animations/gsap'
import motion from '@/mixins/motion'
import MarqueeText from '@/components/ui/MarqueeText.vue'

export default {
  name: 'ShopView',
  components: { MarqueeText },
  mixins: [motion],
  mounted() {
    this.motion(() => {
      if (prefersReducedMotion()) return
      const split = SplitText.create(this.$refs.title, { type: 'words,chars', mask: 'chars' })
      gsap.timeline({ delay: 0.35 })
        .from(split.chars, { yPercent: 110, duration: 1.2, stagger: 0.03, ease: 'expo.out' })
        .from('[data-shop-in]', { y: 30, opacity: 0, duration: 1, stagger: 0.08, ease: 'expo.out' }, 0.3)
    })
  }
}
</script>

<style scoped>
.shop {
  min-height: 100vh;
  min-height: 100svh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: var(--c-bg);
  color: #fff;
  padding-top: var(--header-h);
}

.shop__inner {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 4rem var(--gutter);
}

.shop__eyebrow {
  margin-bottom: 1.5rem;
}

.shop__title {
  margin-left: -0.04em;
}

.shop__text {
  margin-top: 2rem;
  color: var(--c-muted);
  font-size: var(--fs-lead);
}

.shop__dots {
  display: flex;
  gap: 0.6rem;
  margin-top: 2.5rem;
}

.shop__dots span {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--c-accent);
  animation: bounce 1.2s var(--ease-in-out) infinite;
}

.shop__dots span:nth-child(2) {
  animation-delay: 0.15s;
}

.shop__dots span:nth-child(3) {
  animation-delay: 0.3s;
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
    opacity: 1;
  }
  50% {
    transform: translateY(-12px);
    opacity: 0.5;
  }
}

.shop__marquee {
  font-size: clamp(2.5rem, 1rem + 5vw, 6rem);
  text-transform: uppercase;
  line-height: 1.1;
}
</style>
